export default __webpack_public_path__ + "static/media/kleinbus_kompakt.0ce93716.png";